(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const toggle = event.target.closest('.rs-journal-drawer__toggle');
  if (!toggle) return;
  const panel = document.getElementById(toggle.getAttribute('aria-controls'));
  if (!panel) return;
  const expanded = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!expanded));
  panel.hidden = expanded;
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rs-protection-badge"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.rsProductHelpReady) return;
  window.rsProductHelpReady = true;
  function addHelp() {
    document.querySelectorAll('.rs-editorial__fulfillment').forEach(note => {
      const targetInfo = note.closest('.product__info');
      if (!targetInfo || targetInfo.querySelector('[data-rs-product-chat]')) return;
      const help = document.createElement('p');
      help.className = 'rs-product-chat-help';
      const shipping = note.querySelector('p');
      if (shipping) {
        const style = getComputedStyle(shipping);
        help.style.fontSize = style.fontSize;
        help.style.lineHeight = style.lineHeight;
      }
      help.append('Have questions? ');
      const link = document.createElement('a');
      link.href = '/pages/contact';
      link.textContent = 'Ask us';
      link.setAttribute('data-rs-product-chat', '');
      link.setAttribute('aria-haspopup', 'dialog');
      help.append(link);
      const info = note.closest('.product__info');
      const dimensions = info?.querySelector('.rs-catalog-dimensions');
      if (dimensions) dimensions.insertAdjacentElement('afterend', help);
      else note.append(help);
    });
  }
  function launcher(root) {
    if (!root) return null;
    const button = root.querySelector('button[part~="activator"]');
    if (button) return button;
    for (const node of root.querySelectorAll('*')) {
      if (node.shadowRoot) {
        const found = launcher(node.shadowRoot);
        if (found) return found;
      }
    }
    return null;
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-rs-product-chat]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    const started = Date.now();
    function open() {
      const button = launcher(document.querySelector('shopify-chat')?.shadowRoot);
      if (button) {
        if (button.getAttribute('aria-expanded') !== 'true') button.click();
      } else if (Date.now() - started < 4000) window.setTimeout(open, 200);
      else window.location.assign(link.href);
    }
    window.setTimeout(open, 0);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addHelp, {once:true});
  else addHelp();
  document.addEventListener('shopify:section:load', addHelp);
})();
  } catch(e) { console.error(e); }
})();

})();
